<caremoni-dialog-template
    id="excreation-setting"
    [dialogTemplate]="dialogTemplate" 
    (closeModalHandler)="closeModal()">
    <div modal-body>
        <p-tabs value="0" (valueChange)="onSaucerLogChangeTab($event)">
            <p-tablist>
                <p-tab value="0" tabindex="1">{{CHECKSHEETSETTINGDIALOG.DISPLAY_SETTING_NYUSHO}}</p-tab>
                <p-tab value="2" class="border-tab" tabindex="2">{{CHECKSHEETSETTINGDIALOG.SETTING_CONFIG}}</p-tab>  
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel value="0">
                    <div class="nyusho-container">
                        <div class="nyusho-row">
                            <label class="row-name unit-filtering nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.SORT_ORDER}}
                            </label>
                            <div class="select-box-wrapper nyusho-action">
                                <div class="nyusho-item" (click)="onRadioClick(EXCREATION_SORT_TYPE.BY_EXCREATION_TIME)">
                                    <caremoni-radio-button [isChecked]="sortType === EXCREATION_SORT_TYPE.BY_EXCREATION_TIME"
                                        [disabled]="false">
                                    </caremoni-radio-button>
                                    <label for="rdSortBathRoom" [ngClass]="{'disabled': false}"
                                        class="nyusho-lbl">{{CHECKSHEETSETTINGDIALOG.EXCREATTION_TIME}}</label>
                                </div>
                                <div class="nyusho-item" (click)="onRadioClick(EXCREATION_SORT_TYPE.BY_ROOM)">
                                    <caremoni-radio-button [isChecked]="sortType === EXCREATION_SORT_TYPE.BY_ROOM"
                                        [disabled]="false">
                                    </caremoni-radio-button>
                                    <label for="rdSortRoom" [ngClass]="{'disabled': false}"
                                        class="nyusho-lbl">{{CHECKSHEETSETTINGDIALOG.SORT_ROOM_NYUSHO}}</label>
                                </div>
                                <div class="nyusho-item" (click)="onRadioClick(EXCREATION_SORT_TYPE.BY_NAME)">
                                    <caremoni-radio-button [isChecked]="sortType === EXCREATION_SORT_TYPE.BY_NAME"
                                        [disabled]="false">
                                    </caremoni-radio-button>
                                    <label for="rdSortName" [ngClass]="{'disabled': false}"
                                        class="nyusho-lbl">{{CHECKSHEETSETTINGDIALOG.SORT_NAME_NYUSHO}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="nyusho-row">
                            <label class="nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.DISPLAY_UNIT_NYUSHO}}
                            </label>
                            <div class="nyusho-action">
                                <div class="nyusho-item">
                                    <caremoni-multi-select-box 
                                        class="unit-select"
                                        [options]="displayUnits" 
                                        [selectedValues]="unitSelected" 
                                        (valueChange)="onChangeUnit($event)">
                                    </caremoni-multi-select-box>
                                </div>
                            </div>
                        </div>
                        <div class="nyusho-row">
                            <label class="nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.DISPLAY_GROUP_NYUSHO}}
                            </label>
                            <div class="nyusho-action">
                                <div class="nyusho-item">
                                    <caremoni-multi-select-box 
                                        class="unit-select"
                                        [options]="displayGroups" 
                                        [selectedValues]="groupSelected" 
                                        (valueChange)="onChangeGroup($event)">
                                    </caremoni-multi-select-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-tabpanel>
               
                <p-tabpanel value="2">
                    <div class="setting-config">
                        <div class="display-row">
                            <div class="filter-content">
                                <label>{{CHECKSHEETSETTINGDIALOG.TIME_CHANGE_PAGE}}</label>
                                <div class="option-group">
                                    <caremoni-textbox class="input-unit" [canClear]="false"
                                        [inputValue]="timeChangePage"
                                        [inputParams]="inputParams"
                                        (onKeyDown)="onInputKeyDown($event)"
                                        (focusout)="onFocusOutInput($event)"
                                        (inputValueChange)="onChangeSettingTime($event)">
                                    </caremoni-textbox>
                                    <label class="option-label">秒</label>
                                </div>
                            </div>
                        </div>
                        <div class="display-row">
                            <div class="filter-content">
                                <label>{{CHECKSHEETSETTINGDIALOG.MARQUEE_SPEED}}</label>
                                <div class="option-group">
                                    <caremoni-select-box class="marquee-speed-select"
                                        [options]="marqueeSpeedOptions"
                                        [selectedValue]="marqueeSpeedRate"
                                        (valueChange)="onChangeMarqueeSpeed($event)">
                                    </caremoni-select-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>

    <div modal-bottom *ngIf="dialogTemplate.hasBottom">
        <div class="d-flex justify-content-center">
            <button class="button-bottom" (click)="onSubmit()" tabindex="40">
              {{CHECKSHEETSETTINGDIALOG.BTN_CONFIRM}}
            </button>
        </div>
    </div>
</caremoni-dialog-template>